"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.sort.js");
var _react = _interopRequireWildcard(require("react"));
var _functions = require("../../utils/functions");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl/FormControl"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SelectField = _ref => {
  let {
    filter,
    activeFilters,
    updateSelector,
    updateActiveFilter,
    filterPanelData,
    theme
  } = _ref;
  return (0, _react.useMemo)(() => {
    const {
      id,
      name = ''
    } = filter;
    const getOptionsStructure = (obj, name) => obj.reduce((acc, c) => [...acc, {
      value: c[name],
      label: c[name],
      count: c.count
    }], []);
    let options = getOptionsStructure(filterPanelData[name] || [], name);
    options = options.sort((a, b) => {
      var _getTextByLanguage, _getTextByLanguage2;
      const value1 = (_getTextByLanguage = (0, _functions.getTextByLanguage)(a.value)) === null || _getTextByLanguage === void 0 ? void 0 : _getTextByLanguage.toUpperCase();
      const value2 = (_getTextByLanguage2 = (0, _functions.getTextByLanguage)(b.value)) === null || _getTextByLanguage2 === void 0 ? void 0 : _getTextByLanguage2.toUpperCase();
      if (value1 < value2) {
        return -1;
      } else if (value1 > value2) {
        return 1;
      } else return 0;
    });
    return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
      key: id,
      sx: {
        minWidth: 120
      }
    }, /*#__PURE__*/_react.default.createElement(_index.Select, {
      value: activeFilters[name],
      updateSelector: updateSelector,
      removeSelect: updateActiveFilter,
      item: filter,
      options: options,
      removeBtn: true,
      count: true,
      theme: theme
    }));
  }, [activeFilters, filter, filterPanelData, theme]);
};
var _default = exports.default = SelectField;